import type { ExternalLinkType } from '@up2stay/up2promo-api-client';
import { toExternalHref } from '@up2stay/up2promo-commons';

/** Local form state for location external links (always includes writable type + value). */
export type LocationLinkEntry = {
  type: ExternalLinkType;
  value: string;
};

export function externalLinksFromLocation(
  links:
    | Array<{ type?: ExternalLinkType | string; value?: string | null }>
    | null
    | undefined,
): LocationLinkEntry[] {
  return (links ?? [])
    .filter(
      (e): e is { type: ExternalLinkType; value?: string | null } =>
        !!e?.type &&
        (e.type === 'menu' ||
          e.type === 'instagram' ||
          e.type === 'facebook' ||
          e.type === 'tiktok'),
    )
    .map((e) => ({
      type: e.type,
      value: e.value ?? '',
    }));
}

export function toExternalLinkItemDtos(entries: LocationLinkEntry[]) {
  return entries.map((e) => ({
    type: e.type,
    value:
      e.type === 'instagram' || e.type === 'tiktok'
        ? e.value.trim().replace(/^@/, '')
        : toExternalHref(e.value),
  }));
}
